import { Box } from "@mui/material";

import Header from "../../components/Header";
//import DataGrid from "devextreme-react/data-grid";

import React, { useEffect, useState } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";

import { useDispatch, useSelector } from "react-redux";
import ViolationList from "../../components/Violation/violationList";
import { getViolation } from "../../store/reducers/violation";
import moment from "moment";

const Violation = () => {
  const violationDataList = useSelector(
    (state) => state.violation.violationData
  );
  const filter = useSelector((state) => state.violation.filter);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [isCompanyFilter, setIsCompanyFilter] = useState(false);
  const [compName, setCompanyName] = useState("");
  const logedUser = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  //  console.log(isNonMobile);
  useEffect(() => {
    if (violationDataList == null) {
      dispatch(
        //  getViolation(filter)
        getViolation({
          ...filter,
          start_date: moment().startOf("month").format("YYYY-MM-DD"),

          end_date: moment().subtract(0, "days").format("YYYY-M-D"),
        })
      );
      // if (logedUser.role === "admin") {
      //   dispatch(setFilter({ is_approved: 1 }));
      // }
    }
  }, [violationDataList, logedUser, filter, dispatch]);
  useEffect(() => {
    //console.log(Object.keys(filter).length);
    if (Object.keys(filter).length > 0) {
      dispatch(getViolation(filter));
    }
  }, [filter, dispatch]);
  // const filterIsCompany = (filterData) => {
  //   // console.log(filterData);
  //   //const data = selectedRowsData[0];
  //   if (filterData !== null) {
  //     setCompanyName(filterData[0]);
  //     setIsCompanyFilter(true);
  //   } else {
  //     setCompanyName(null);
  //     setIsCompanyFilter(false);
  //   }
  // };
  // console.log(violationDataList);
  return (
    <Box m="20px">
      <Header title="Зөрчил" subtitle="Зөрчил жагсаалт" />
      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 12" },
        }}
      >
        {/* <Box sx={{ gridColumn: "span 12" }}>
          <FilterBox getFilters={setFilters} filterCompany={filterIsCompany} />
        </Box> */}
        <Box sx={{ gridColumn: "span 12" }}>
          <ViolationList violationDataList={violationDataList} />
        </Box>
      </Box>
    </Box>
  );
};

export default Violation;
